module.exports = __webpack_public_path__ + "img/Benoit_Huet@2x.e2a4ce68.png";